<template>
  <nav-bar title="部门监管工作落实情况统计明细" />
  <Content :bottom="0">
    <div class="title" v-if="props.cType =='03'">{{list.stName}}{{list.ctitle}}完成情况明细</div>
    <div class="title" v-else>{{list.stName}}{{list.ctypeName}}完成情况明细</div>
    <div class="list-item" v-for="item in list.infoList" :key="item.regionCode">
      <div style="display: flex; align-items: center" @click="handleClick(item)" >
        <div :class="item.level < 4 ? 'link' : 'nolink'">{{ item.regionName }}</div>
        <van-button type="primary" size="small" :to="`/supervise/${item.regionCode}`">督办</van-button>
      </div>
      <div :class="item.level < 4 ? 'link' : 'nolink'">
        <span>应检查：{{ item.planNum }}</span>
        <span v-if="props.cType == '02'">已延期：{{ item.finNum }}</span>
        <span v-else>已检查：{{ item.finNum }}</span>
      </div>
    </div>
  </Content>
</template>

<script>
import { useStore } from 'vuex'
// import { Dialog } from 'vant'
import {
  getCheckInfoList
} from '@/api/supervise'
import { computed, ref } from 'vue'
import { useGetData } from '@/hooks/useGetData'
export default {
  name: 'checkInfo',
  props: ['cId', 'cType'],
  setup(props) {
    const store = useStore()
    const streetCode = computed(() => store.state.roleInfo.companyId)
    // 检查情况统
    const list = ref([])
    useGetData(getCheckInfoList, data => {
      list.value = data
    })({
      cId: props.cId,
      cType: props.cType,
      stId: streetCode.value
    })

    const handleClick = (item) => {
      if (item.level < 4) {
        useGetData(getCheckInfoList, data => {
          list.value = data
        })({
          cId: props.cId,
          cType: props.cType,
          stId: item.regionCode
        })
      } else {
        // Dialog.alert({
        //   message: '明细数据只提供到街道级别。'
        // }).then(() => {
        //   // on close
        // })
      }
    }
    return {
      list,
      handleClick,
      props
    }
  }
}
</script>

<style lang="scss" scoped>
  .title {
    padding: 16px;
    font-size: 16px;
    font-weight: 600;
    color: #333;
  }
  .title_l {
    padding: 12px;
    font-size: 16px;
    font-weight: 600;
    color: #333;
    background-color: #b6e6ff;
  }
  .checkNum {
    font-size: 14px;
    padding: 0 16px;
    color: #333;
  }
  .list-item {
    padding: 16px;
    background-color: #fff;
    margin-bottom: 10px;
    p {
      font-size: 15px;
      font-weight: 600;
      color: #333;
    }
    /* span {
      font-size: 14px;
      color: #666;
      margin-right: 16px;
    } */
  }
  .detail {
    font-size: 14px;
    padding: 16px;
    background-color: #fff;
    span {
      margin-right: 10px;
    }
  }
  .link {
    text-decoration: underline;color: blue; font-size: 16px;flex:1
  }
  .nolink{
    color: #666; font-size: 16px;flex:1
  }
</style>
